const ptPT = {
  navigation: {
    mydevice: "O meu dispositivo",
    mymobile: "O meu telemóvel"
  },
  photoorganiser: {
    navigation: {
      photos: "Fotos",
      favorites: "Favoritos",
      collections: "Coleções",
      events: "Eventos",
      latestuploads: "Últimos carregamentos"
    },
    empty(source) {
      return "Não tem fotos em " + source
    }
  },
  mymobile: {
    title: "Obtenha as fotos do seu telefone num instante!",
    qrcode: {
      title: "Ler o código QR",
      subtitle: "(Não é necessário instalar a aplicação)"
    },
    instruction: {
      title: "Vamos começar!",
      step_1: "Abra a aplicação da câmara",
      step_2: "Ler o código QR",
      step_3: "Siga as instruções no seu telemóvel"
    }
  },
  layout: {
    flex: "Flex",
    square: "Quadrado"
  },
  calender: {
    allmonths: "Todos os meses",
    allyears: "Todos os anos",
    months: {
      january: "janeiro",
      february: "fevereiro",
      march: "março",
      april: "abril",
      may: "maio",
      june: "junho",
      july: "julho",
      august: "agosto",
      september: "setembro",
      october: "outubro",
      november: "novembro",
      december: "dezembro"
    }
  },
  generic: {
    sortBy: "ordenar por",
    selected: "selecionado(s)",
    done: "Adicionar fotos",
    back: "Voltar",
    images: "fotos",
    removeall: "Apagar tudo",
    selection: "Seleção",
    date: "Data",
    name: "Nome",
    az: "Nome do ficheiro A-Z",
    za: "Nome do ficheiro Z-A",
    newestfirst: "Data mais recente-antigo",
    oldestfirst: "Data mais antigo-recente",
    photos: "fotos",
    all: "Tudo",
    yes: "sim",
    no: "não",
    nodate: "Sem data"
  },
  rangeText: {
    minMax(min, max) {
      return "Deve escolhente entre " + min + " e " + max + " fotos"
    },
    min(min) {
      return "Vai precisar de pelo menos " + min + " para criar o seu livro."
    },
    max(max) {
      return "Tem que escolher no máximo " + max + "  fotos"
    }
  },
  addMorePhotos: "Adicionar mais fotos",
  upload: {
    browseButton: "Adicionar fotos",
    uploadlimit(maxSize) {
      return "As fotos devem ter um tamanho de " + maxSize + " ou inferior"
    },
    dragImage: "ou arraste e largue fotos aqui.",
    errors: {
      GENERIC_ERROR: "Ocorreu um erro. Tente novamente mais tarde ou contacte o nosso serviço de apoio a clientes.",
      EMPTY_FILE: "Perdeu-se a referência da imagem - por favor, adicione a imagem de novo",
      MAX_FILE_SIZE: "O ficheiro tem de ser inferior a {0} MB",
      UNSUPPORTED_FILE_TYPE: "Este formato de ficheiro não é suportado",
      MAX_IMAGE_RESOLUTION: "O ficheiro tem de ter menos de {0} píxeis",
      INVALID_IMAGE: "O ficheiro está corrompido"
    },
    errorSummary(number) {
      return number + " não foi possível carregar os ficheiros"
    },
    errorDialog: {
      headline: "Ups!",
      ingress: "Não foi possível carregar os seguintes ficheiros:",
      filenameColumn: "Ficheiro",
      reasonColumn: "Motivo"
    },
    uploaded: "Carregado",
    estimating: "A calcular tempo",
    estimatedleft: "Tempo restante previsto",
    ok: "OK",
    cancel: "Cancelar",
    details: "Detalhes"
  }
}

export default ptPT
